import React from 'react'
import Column from 'modules/ui/atoms/Layout/Column'
import Row from 'modules/ui/atoms/Layout/Row'
import useFlow from 'modules/flow/state/use-flow'
import FlowTwoColumnStepLayout from 'modules/flow/components/two-column-step-layout/two-column-step-layout'
import AmountCurrencyFrequencySection from '../dcf-nudge-step/components/amount-currency-frequency-section'
import useOrder from 'modules/order/state/order/use-order'
import { useTranslation } from 'next-i18next'
import { PaymentMethodSelector } from './components/payment-method-selector'
import { PaymentMethodActionButton } from './components/payment-method-action-button'
import { PaymentMethodSecureNotice } from './components/payment-method-secure-notice'

const PaymentMethodsStep = () => {
  const { i18n } = useTranslation()
  const flow = useFlow()
  const order = useOrder()

  return (
    <>
      <FlowTwoColumnStepLayout.Header
        title={flow.currentStep.title}
        backButtonDataId="payment-methods-step-back-button"
      />
      <FlowTwoColumnStepLayout.Body>
        <Column>
          <Row
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'end',
              paddingTop: '20px',
            }}
          >
            <AmountCurrencyFrequencySection
              amount={order.amount.value}
              currency={order.currency.value}
              frequency={order.frequency.value}
              locale={i18n.language}
            />
          </Row>
          <PaymentMethodSecureNotice />
          <Row>
            <PaymentMethodSelector />
          </Row>
        </Column>
      </FlowTwoColumnStepLayout.Body>
      <FlowTwoColumnStepLayout.Footer>
        <PaymentMethodActionButton dataIdPrefix="payment-method-continue-button" />
      </FlowTwoColumnStepLayout.Footer>
    </>
  )
}

export default PaymentMethodsStep
